import { Link } from "react-router-dom";
import { LogIn, LogOut, UserRound, Gauge } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { T, useLang, LangSwitch } from "@/i18n";

export const Logo = ({ light, compact }) => (
  <a href="/" data-testid="brand-logo" className="flex shrink-0 items-center gap-2.5" aria-label="TripSaver">
    <img src={light ? "/tripsaver-mark-light.png" : "/tripsaver-mark.png"} alt="" className="h-10 w-auto" />
    <img src={light ? "/tripsaver-wordmark-light.png" : "/tripsaver-wordmark.png"} alt="TripSaver" className={`h-7 w-auto ${compact ? "hidden sm:block" : ""}`} />
  </a>
);

const links = [
  { href: "/#come-funziona", label: "Come funziona", id: "nav-how" },
  { href: "/#crea-viaggio", label: "Crea viaggio", id: "nav-create" },
];

const AuthButtons = () => {
  const { user, openAuth, logout } = useAuth();
  const { t } = useLang();
  if (user === null) return <span className="w-24" />;
  if (!user) {
    return (
      <button data-testid="header-login-button" onClick={() => openAuth()}
        className="inline-flex items-center gap-2 rounded-full bg-white/15 px-3.5 py-2.5 text-sm font-semibold text-white backdrop-blur-md ring-1 ring-white/30 transition-colors hover:bg-white hover:text-emerald-800 sm:px-5" aria-label={t("Accedi")}>
        <LogIn className="h-4 w-4" /><span className="hidden sm:inline"><T>Accedi</T></span>
      </button>
    );
  }
  return (
    <div className="flex items-center gap-1.5 sm:gap-2">
      {user.role === "admin" && (
        <Link to="/admin" data-testid="header-admin-link"
          className="inline-flex items-center gap-2 rounded-full bg-emerald-500 px-3.5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-emerald-400 sm:px-4" aria-label="Admin">
          <Gauge className="h-4 w-4" /><span className="hidden sm:inline">Admin</span>
        </Link>
      )}
      <Link to="/account" data-testid="header-my-trips-link"
        className="inline-flex items-center gap-2 rounded-full bg-white/15 px-3.5 py-2.5 text-sm font-semibold text-white backdrop-blur-md ring-1 ring-white/30 transition-colors hover:bg-white hover:text-emerald-800 sm:px-5" aria-label={t("I miei viaggi")}>
        <UserRound className="h-4 w-4" /><span className="hidden sm:inline"><T>I miei viaggi</T></span>
      </Link>
      <button data-testid="header-logout-button" onClick={logout} aria-label={t("Esci")} title={t("Esci")}
        className="grid h-9 w-9 shrink-0 place-items-center rounded-full sm:h-10 sm:w-10 text-white/80 transition-colors hover:bg-white/15 hover:text-white">
        <LogOut className="h-4 w-4" />
      </button>
    </div>
  );
};

export const SiteHeader = () => (
  <header data-testid="main-header" className="no-print absolute inset-x-0 top-0 z-30">
    <div className="mx-auto flex max-w-7xl items-center justify-between gap-3 px-4 py-6 sm:px-6 md:px-10">
      <Logo light compact />
      <nav className="hidden items-center gap-8 md:flex">
        {links.map((l) => (
          <a key={l.id} href={l.href} data-testid={l.id}
            className="text-sm font-medium text-white/80 transition-colors hover:text-white">
            <T>{l.label}</T>
          </a>
        ))}
      </nav>
      <div className="flex items-center gap-2 sm:gap-3">
        <LangSwitch />
        <AuthButtons />
      </div>
    </div>
  </header>
);
